import { api } from 'src/api';

// Direct API calls, not a store action: an action's run() cancels its own call in flight, and the setup page shows a
// section per utility (LB-6190).
const NO_OPTIONS = {
  cancelToken: {}
};

// Long enough for every section on a page, and the next page, to share one read. An address changes only when staff
// rotate or generate it, and that drops the read here (forgetIntakeAddress).
const KEEP_MS = 60 * 1000;
const kept = new Map();

// localStorage holds the company id in lower case, and the admin screens pass it as the server wrote it.
const keyOf = companyId => String(companyId).toLowerCase();
const fetchAddress = async companyId => {
  try {
    var _resp$response;
    const resp = await api.Companies.getBillIntakeAlias({
      companyId
    }, NO_OPTIONS);
    // An answer holding no address is a company with none, as the Bills page banner reads it.
    if (!resp) return null;
    const address = (_resp$response = resp.response) === null || _resp$response === void 0 ? void 0 : _resp$response.address;
    return {
      address: typeof address === 'string' && address ? address : null
    };
  } catch (_unused) {
    return null;
  }
};

/**
 * The company's bill-intake address (LB-6029): `{ address }`, `{ address: null }` when it has none, or null when it
 * can't be read. Reading never creates one. One read serves every caller for the company, and it's kept a minute; a
 * failed read isn't kept, so the next caller asks again.
 */
export const readIntakeAddress = companyId => {
  const key = keyOf(companyId);
  const now = Date.now();
  const entry = kept.get(key);
  if (entry && now - entry.at < KEEP_MS) return entry.read;
  const read = fetchAddress(companyId).then(answer => {
    var _kept$get;
    if (!answer && ((_kept$get = kept.get(key)) === null || _kept$get === void 0 ? void 0 : _kept$get.read) === read) kept.delete(key);
    return answer;
  });
  kept.set(key, {
    read,
    at: now
  });
  return read;
};

/** Forget one company's kept answer: its address was rotated or generated just now. */
export const forgetIntakeAddress = companyId => kept.delete(keyOf(companyId));

/** Forget every kept answer: on logout, so the next session in this tab reads with its own token. */
export const forgetIntakeAddresses = () => kept.clear();